import React from 'react'

const Category = ({ category, isActive, onFocus }) => {
  return (
    <button
      role="switch"
      aria-checked={String(isActive)}
      className={`flex ${isActive ? 'border-success-200' : 'border-transparent'} px-[4px] border-2 transition-all duration-200 ease flex-col cursor-pointer justify-center items-center w-[9rem] h-[154px] bg-primary-50 rounded-[10px] text-white`}
      onClick={() => onFocus(category.slug)}
    >
      <img
        src={category.image}
        alt={category.name}
        draggable={false}
        className="w-[64px] h-[64px]"
      />

      <span className="select-none mt-[10px] text-center text-primary-100 text-[18px] font-semibold">
        {category.name}
      </span>
    </button>
  )
}

export default Category
